import { createFileRoute } from '@tanstack/react-router'

import { loadReviewsRedirect } from '@/screens/brokers/ReviewsRedirect.loader'

/**
 * `/brokers/reviews` — the Reviews row and tab with no house in view. See
 * `ByStockRedirect.tsx` for why `component` never renders on a real visit.
 */
export const Route = createFileRoute('/_app/brokers/reviews')({
  loader: loadReviewsRedirect,
  component: () => null,
})
